import React from 'react';
import StepIndicator from './StepIndicator';
import { useTranslation } from 'react-i18next';

function ChipFeedbackScreen({
  stepTitleHtml,
  stepSubtitle,
  chips,
  step,
  feedbackChips,
  onChangeChips,
  feedbackText,
  onChangeText,
  onConfirm,
  onBack,
  onClose,
  isSubmitting,
}) {
  const { t } = useTranslation();
  const getLabel = (chip) =>
    typeof chip === 'string' ? chip : t(chip.key, { defaultValue: chip.label });

  const toggleChip = (label) => {
    if (feedbackChips.includes(label)) {
      onChangeChips(feedbackChips.filter((c) => c !== label));
    } else {
      onChangeChips([...feedbackChips, label]);
    }
  };

  const hasChip = feedbackChips.length > 0;
  const hasText = feedbackText.trim().length > 0;
  const canConfirm = hasChip || hasText;

  return (
    <>
      <StepIndicator step={2} onBack={onBack} showBack onClose={onClose} />

      <div className="t-mb-4">
        <h2
          className="t-text-[26px] t-font-serif t-text-slate-900 t-leading-tight t-mb-2"
          dangerouslySetInnerHTML={{ __html: stepTitleHtml }}
        />

        <p className="t-text-sm t-text-slate-600 t-m-0">{stepSubtitle}</p>
      </div>

      <div className="t-flex t-flex-wrap t-gap-2 t-mb-3">
        {chips.map((chip) => {
          const label = getLabel(chip);
          const active = feedbackChips.includes(label);
          return (
            <button
              key={label}
              type="button"
              onClick={() => toggleChip(label)}
              className={`t-px-4 t-py-2 t-rounded-full t-border t-text-[13px] t-transition
              ${
                active
                  ? 't-border-secondary t-bg-teal-bg t-text-secondary t-font-semibold'
                  : 't-border-slate-200 t-text-slate-600 hover:t-border-secondary hover:t-bg-teal-bg'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>

      <textarea
        className="t-w-full t-h-24 t-rounded-xl t-border t-border-slate-200 t-px-3 t-py-2 t-text-sm t-text-slate-800 focus:t-outline-none focus:t-border-teal-600 t-mb-3"
        placeholder={t('CancelFlow_Chip_Placeholder')}
        value={feedbackText}
        onChange={(e) => onChangeText(e.target.value)}
      />

      <div className="t-flex t-items-center t-gap-2 t-bg-[#EAF4F1] t-border-l-4 t-border-secondary t-rounded-lg t-px-3 t-py-2 t-text-[12px] t-text-slate-700 t-mb-4">
        <span className="!t-text-secondary">🛡</span>
        <span>
          {step === 'taste'
            ? t('CancelFlow_Chip_Info_Taste')
            : t('CancelFlow_Chip_Info_Format')}
        </span>
      </div>

      <button
        type="button"
        onClick={onConfirm}
        disabled={!canConfirm || isSubmitting}
        className="t-w-full t-inline-flex t-items-center t-justify-center t-rounded-xl t-px-4 t-py-3 t-bg-secondary t-text-white t-font-semibold t-text-sm t-gap-2 t-shadow-sm hover:t-shadow-[0_4px_12px_rgba(26,107,90,0.28)] t-transition t-mb-2 disabled:t-opacity-50 disabled:t-cursor-not-allowed"
      >
        <span>{t('CancelFlow_Chip_Confirm')}</span>
        <span aria-hidden="true">✓</span>
      </button>

      <button
        type="button"
        onClick={onClose}
        disabled={isSubmitting}
        className="t-block t-w-full t-text-center t-text-sm t-text-slate-600 hover:t-text-slate-800"
      >
        {t('CancelFlow_Chip_NeverMind')}
      </button>
    </>
  );
}

export default ChipFeedbackScreen;
